export const GET_ACTIVE_RULES = 'GET_ACTIVE_RULES'
